module.exports = new __parcel__URL__("contract.a02eadc2.png").toString();